import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Carousel from "./Carousel";
import './General.css';
import './Buttons.css';


function LandingPageV2() {
  const [showForm, setShowForm] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [messageInput, setMessageInput] = useState("");
  const [message, setMessage] = useState("");
  // const sendEmail = (e) => {
  //   e.preventDefault();
  //   emailjs
  //     .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
  //     .then(
  //       () => setMessage("Merci ! Vous serez contacté très bientôt."),
  //       (error) => setMessage("Erreur, veuillez réessayer.")
  //     );
  // };

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleSubmit = (e) => {
    debugger

    // const mailContent = `Nom : ${name} Email : ${email} Téléphone : ${phone} Message : ${messageInput}`;
    const mailContent =
      `Nom : ${name}
       Email : ${email}
       Téléphone : ${phone}
       Message :
      ${messageInput}`;

    var formData = { name: name, message: mailContent };
    e.preventDefault();
    // TODO: Appeler une API ou envoyer par email
    e.preventDefault();
    console.log(formData);
    emailjs
      .send("service_zkyhrvm", "template_x0gfrnn", formData, "3IvYkrLOUnUE7Tsj2")
      .then(
        () => setMessage("Merci ! Vous serez contacté très bientôt."),
        (error) => {
          setMessage("Erreur, veuillez réessayer.")
          console.log(error)
        }
      );
    setEmail("");
    setShowForm(false);
  };
  return (
    <div>
      <header className="yeo-slogan">
        <div className="container yeo-header">
          <div className="columns">
            <div className="column col-12">
              <nav className="navbar">
                <section className="navbar-section">
                  <a className="navbar-brand logo" href="/">
                    <img className="logo-img" src="./images/VISINET_LOGO.png" alt="" />
                    <span>Visinet</span>
                  </a>
                </section>
                <section className="navbar-section hide-sm">
                  <a className="btn btn-link" href="#features">Services</a>
                  <a className="btn btn-link" href="#pricing">Offres</a>
                  <a className="btn btn-link" href="#feedback">Satisfait ou remboursé</a>
                  <a className="btn btn-link" href="#contact">Contact</a>
                </section>
                <section className="navbar-section phone-contact">
                  <a href="tel:+212612345678" className="phone-link">
                    📞 +212 6 53 34 95 77
                  </a>
                </section>
                <section className="navbar-section hide-sm mail-contact">
                  <a href="tel:+212612345678" className="mail-link">
                    ✉️ contact.visinet@gmail.com
                  </a>
                </section>
              </nav>
            </div>
          </div>
        </div>

        <div className="container slogan text-center">
          <h1>Des sites web qui font grandir votre activité</h1>
          <p className="slogan-text">
            Visinet est une agence digitale spécialisée dans la création de sites web modernes, rapides et optimisés pour la visibilité en ligne<br /> Un seul outil, zéro stress, 100 % de contrôle.
          </p>

          {/* <a className="btn btn-primary btn-lg" href="#contact">Contactez-nous sur WhatsApp</a> */}
          <div className="cta-container">
            <a className="btn btn-primary btn-lg cta-buttons" href="#contact">
              📄 Demander un devis gratuit
            </a>

            <a
              className="btn btn-success btn-lg cta-buttons"
              href="https://wa.me/212603176758"
              target="_blank"
              rel="noopener noreferrer"
            >
              💬 Parler sur WhatsApp
            </a>
          </div>

        </div>
      </header>
      <br />
      <section className="yeo-target" id="target">
        <div className="container text-center">
          <h2>À qui s’adresse nos services ?</h2>
          <div className="columns">
            <div className="column col-4">
              <h4>🏥 Médecins & cabinets médicaux</h4>
              <p>Sites web professionnels pour présenter vos services et faciliter le contact avec les patients.</p>
            </div>
            <div className="column col-4">
              <h4>🎓 Écoles & centres de formation</h4>
              <p>Sites modernes pour attirer plus d’élèves et renforcer votre crédibilité.</p>
            </div>
            <div className="column col-4">
              <h4>🏢 Entreprises & indépendants</h4>
              <p>Sites vitrines pour améliorer votre visibilité et générer plus de clients.</p>
            </div>
          </div>
        </div>
      </section>
      <br />
      <section className="yeo-features" id="features">
        <div className="container text-center">
          <h2>Nos Services</h2>
          <div className="columns">
            <div className="column col-4">
              <h3>🌐 Site vitrine professionnel</h3>
              <p>Créez un site moderne pour présenter votre entreprise et vos services en ligne, accessible sur tous les appareils.</p>
            </div>
            <div className="column col-4">
              <h3>📱 Responsive design</h3>
              <p>Votre site s’adapte parfaitement à tous les écrans : mobiles, tablettes et ordinateurs.</p>
            </div>
            <div className="column col-4">
              <h3>⚡ Mise en ligne rapide</h3>
              <p>Nous prenons en charge l’hébergement et la mise en ligne pour que votre site soit opérationnel immédiatement.</p>
            </div>
            <div className="column col-6">
              <h3>🔍 SEO de base</h3>
              <p>Optimisation pour que votre entreprise commence à apparaître sur Google et attirer de nouveaux clients.</p>
            </div>
            <div className="column col-6">
              <h3>💬 Whatsapp / Google Maps</h3>
              <p>Intégration de WhatsApp et Google Maps pour faciliter le contact et la localisation de votre entreprise.</p>
            </div>
          </div>
        </div>
      </section>
      <Carousel />
      <section className="yeo-pricing" id="pricing">
        <div className="container text-center">
          <h2>Des offres claires pour créer votre site web professionnel</h2>

          <div className="columns">

            <div className="column col-4">
              <h3>🚀 Site Essentiel</h3>
              <p><strong>À partir de 1 500 MAD</strong></p>
              <p>
                Idéal pour démarrer votre présence en ligne :<br />
                - Site vitrine (1 à 3 pages)<br />
                - Design responsive (mobile & desktop)<br />
                - Bouton WhatsApp & formulaire de contact<br />
                - Google Maps<br />
                - Mise en ligne incluse
              </p>
            </div>

            <div className="column col-4">
              <h3>⭐ Site Business</h3>
              <p><strong>À partir de 3 000 MAD</strong></p>
              <p>
                Parfait pour développer votre activité :<br />
                - Jusqu’à 6 pages<br />
                - Design personnalisé<br />
                - SEO de base & performance<br />
                - Adresses email professionnelles<br />
                - Accompagnement au lancement
              </p>
            </div>

            <div className="column col-4">
              <h3>🧩 Site Sur Mesure</h3>
              <p><strong>Sur devis</strong></p>
              <p>
                Pour des besoins spécifiques :<br />
                - Fonctionnalités personnalisées<br />
                - Multilingue (FR / AR)<br />
                - Intégrations spécifiques<br />
                - Suivi et évolutivité
              </p>
            </div>
            <div className="column col-12">
              <p className="pricing-note">
                Chaque projet est unique. Les tarifs peuvent varier selon vos besoins.
              </p>
            </div>


          </div>

        </div>
      </section>
      <br />
      <section className="yeo-contact" id="feedback">
        <div className="container text-center">
          <h2>Garantie « 100 % satisfait ou remboursé »</h2>
          <p>
            Nous créons votre site web selon vos besoins.<br />
            Si le résultat final ne vous convient pas, nous le modifions jusqu’à satisfaction.<br />
            Et si vous n’êtes toujours pas satisfait, nous vous remboursons.
          </p>
          <p>
            Votre satisfaction est notre priorité.
          </p>
        </div>
      </section>
      <br />
      <section className="yeo-contact" id="contact">
        <div className="container text-center">
          <h2>Obtenez une démo personnalisée</h2>
          <p>Laissez-nous vos coordonnées pour planifier une démo adaptée à vos besoins.</p>

          {showForm ? (
            <form onSubmit={handleSubmit} className="form-group" style={{ maxWidth: '400px', margin: '0 auto' }}>
              <input
                type="text"
                className="form-input"
                placeholder="Votre nom complet"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{ marginBottom: '10px' }}
              />
              <input
                type="email"
                className="form-input"
                placeholder="Votre adresse email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ marginBottom: '10px' }}
              />
              <input
                type="tel"
                className="form-input"
                placeholder="Votre téléphone (optionnel)"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{ marginBottom: '10px' }}
              />
              <textarea
                className="form-input"
                placeholder="Questions ou besoins spécifiques ? (optionnel)"
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
                rows={3}
                style={{ marginBottom: '10px' }}
              />
              <button type="submit" className="btn btn-primary mt-2" style={{ width: '100%' }}>
                Envoyer
              </button>
            </form>
          ) : (
            <button className="btn btn-primary" onClick={() => setShowForm(true)}>
              📄 Demander un devis gratuit
            </button>
          )}
          {message && <p className="mt-4">{message}</p>}
        </div>
      </section>

      <br />
      <footer className="yeo-footer">
        <div className="container text-center">
          <p>Visinet.ma &copy; 2025</p>
        </div>
      </footer>

    </div>
  );
}

export default LandingPageV2;
